module.exports = __webpack_public_path__ + "img/web_page04.82dac1e3.png";